<template>
  <el-dialog
    :visible.sync="visible"
    :title="!colData.id ? $t('common.addNew') : $t('common.edit')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
    class="dv_update"
  >
    <el-form
      ref="dataForm"
      :model="colData"
      :style="{'max-height':maxHeight, 'overflow-y':'scroll'}"
    >
      <el-form-item label="序号" :style="{'display':'none'}">
        <el-input v-model="colData.id"></el-input>
      </el-form-item>

      <el-form-item label="群组名称" :required="true">
        <el-input v-model="colData.groupName" placeholder="群组名称"></el-input>
      </el-form-item>

      <el-form-item label="备注">
        <el-input v-model="colData.remark" placeholder="备注" type="textarea" :autosize="true"></el-input>
      </el-form-item>

      <hr class="center-hr">

      <el-form-item label="规则设置" class="left-aligned-label">
        <el-button
          type="primary"
          @click="addRule()"
          :loading="submitBtn.loading"
          icon="el-icon-circle-plus-outline"
        >{{$t('common.add')}}</el-button>
      </el-form-item>

      <!--div class="condition-title">
        <ul>
          <li>项目</li>
          <li>&nbsp;</li>
          <li>值</li>
          <li>{{$t('common.operation')}}</li>
        </ul>
      </div-->
      
      <RULE
        v-for="item in colData.ruleList"
        :key="item.id"
        :ruleData="item"
        :ruleOptions="ruleOptions"
        :accountTags="accountTags"
        :accountLevels="accountLevels"
        :accountStatuses="accountStatuses"
        :registerSources="registerSources"
        :businessTypes="businessTypes"
        @deleteRule="deleteRule"
      ></RULE>

      <hr class="center-hr">

      <el-form-item label="预览群组" class="left-aligned-label">
        <el-button
          type="primary"
          @click="preview()"
          :loading="submitBtn.loading"
          icon="el-icon-search"
        >{{$t('common.preview')}}</el-button>
        <span v-if="previewTotal">总数: {{ previewTotal }}</span>
      </el-form-item>
      
      <el-input v-model="previewResult" placeholder="预览群组 (最多显示100个)" type="textarea" :autosize="true" :readonly="true"></el-input>

    </el-form>

    <template slot="footer">
      <el-button @click="close()">{{$t('page.cancel')}}</el-button>
      <el-button type="primary" @click="submit()" :disabled="submitBtn.disabled" :loading="submitBtn.loading">{{$t('page.submit')}}</el-button>
    </template>

  </el-dialog>
</template>

<script>
import RULE from "@/views/analyse/sms/autoGroupRule";

export default {
  props: {
    ruleOptions: { type: Array, required: true }, //群組規則選項 {id, fieldCode, fieldName, fieldOperator, fieldType}
    accountTags: { type: Array, required: false }, //帳戶標記選項 {key, value}
    accountLevels: { type: Array, required: false }, //帳戶級別選項 {key, value}
    accountStatuses: { type: Array, required: false }, //帳戶狀態選項 {key, value}
    registerSources: { type: Array, required: false }, //開户來源 {key, value}
    businessTypes: { type: Array, required: false }, //業務名稱 {key, value}
    previewResult: { type: String, required: false }, //預覽群組(100个)
    previewTotal: { type: Number, required: false }, //預覽群組总数
  },
  components: {
    RULE
  },
  data() {
    return {
      visible: false,
      maxIdx: 0,
      maxHeight: "",
      colData: {
        id: null,
        groupName: "",
        remark: "",
        ruleList: [],
      },
      submitBtn: {
        loading: false,
        disabled: false,
      },
    };
  },
  methods: {
    open(data) {
      //this.colData = data || {}
      if (data) {
        this.colData = data
      } else {
        this.colData.id = null
        this.colData.groupName = ""
        this.colData.remark = ""
        this.colData.ruleList = []
      }

      this.maxIdx = 0
      for (let r of this.colData.ruleList) {
        r.idx = this.maxIdx++
      }

      //console.log("registerSources: "+JSON.stringify(this.registerSources))
            
      this.visible = true
    },

    close() {
      this.visible = false
    },

    addRule() {
      this.colData.ruleList.push({
        id: null,
        groupId: null,
        ruleField: null,
        ruleOperator: null,
        ruleValue: "",
        ruleValues: [],
        idx: this.maxIdx++
      })
    },

    deleteRule(idx) {
      if (this.colData.ruleList) {
        for (let i = 0; i < this.colData.ruleList.length; i++) {
          if (this.colData.ruleList[i].idx == idx) {
            this.colData.ruleList.splice(i, 1)
            break
          }
        }
      }
    },

    lockSubmitBtn(isLock) {
      this.submitBtn.loading = isLock
      this.submitBtn.disabled = isLock
    },

    submit() {
      this.lockSubmitBtn(true)
      this.$emit("submit", this.colData);
      this.lockSubmitBtn(false)
    },

    preview() {
      this.lockSubmitBtn(true)
      this.$emit("preview", this.colData);
      this.lockSubmitBtn(false)
    },
        
  },
  mounted() {
    this.maxHeight = (window.innerHeight || document.documentElement.clientHeight) / 1.8 + 'px';
  },
};
</script>

<style lang="scss" scoped>
.dv_update .el-form-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.dv_update .el-form-item__content {
  width: 80%;
}
.dv_update .newLine .el-form-item__content {
  width: 100%;
}
.dv_update .el-form-item.newLine {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.dv_update .newLine .el-form-item__label {
  width: 100%;
  background: #fbfbfb;
  text-align: left;
  padding: 0 15px;
  border: solid 1px #e6e6e6;
}
.dv_update .el-upload-dragger {
  width: 200px;
}
.dv_update .el-dialog__footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-hr {
  width: 90%;
  //margin: 0 auto;
  margin-bottom: 20px;
  border: 1px solid #ddd;
}
</style>
